import * as Types from '@frameio/graphql-client/generated/types';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import gql from 'graphql-tag';

import { useQuery, useLazyQuery, useMutation, useFragment, useSubscription } from '@apollo/client';
import type { QueryHookOptions, LazyQueryHookOptions, MutationHookOptions, SubscriptionHookOptions, UseFragmentOptions } from '@apollo/client';

export type UpdateShareLayoutMutationVariables = Types.Exact<{
  shareId: Types.Scalars['ID']['input'];
  layout?: Types.InputMaybe<Types.AssetAggregateLayoutEnum>;
}>;


export type UpdateShareLayoutMutation = { __typename?: 'Mutation', updateShare?: { __typename?: 'UpdateSharePayload', share?: { __typename?: 'AdHocAssetsShare', id: string, appearance: { __typename?: 'AssetAggregateAppearance', layout: Types.AssetAggregateLayoutEnum } } | { __typename?: 'CollectionShare', id: string, appearance: { __typename?: 'AssetAggregateAppearance', layout: Types.AssetAggregateLayoutEnum } } | null } | null };


export const UpdateShareLayout = /*#__PURE__*/ gql`
    mutation UpdateShareLayout($shareId: ID!, $layout: AssetAggregateLayoutEnum) {
  updateShare(input: {shareId: $shareId, settings: {layout: $layout}}) {
    share {
      id
      ... on AssetAggregate {
        appearance {
          layout
        }
      }
    }
  }
}
    ` as unknown as DocumentNode<UpdateShareLayoutMutation, UpdateShareLayoutMutationVariables>;

          

          export const useUpdateShareLayoutMutation = (options?:MutationHookOptions<UpdateShareLayoutMutation, UpdateShareLayoutMutationVariables>) => useMutation(UpdateShareLayout, options);
          

          export type UpdateShareLayoutMutationOptions = MutationHookOptions<UpdateShareLayoutMutation, UpdateShareLayoutMutationVariables>;

          

          export type UpdateShareLayoutMutationResult = ReturnType<typeof useUpdateShareLayoutMutation>[1];

          
